import moment from "moment";
import React from "react";
import Show from "../../../utils/show.component";
import { usd } from "../../../utils/utils";

export const LoanDetailsContent = (props) => {
  const loan = props.loan;

  const DetailsDisplayField = (props) => {
    const titleColumns = props.titleColumns ? "col-" + props.titleColumns : "col-6";
    const valueColumns = props.titleColumns ? "col-" + (12 - props.titleColumns) : "col-6";

    return (
      <div className={"row  mb-1"}>
        <div className={`text-start ` + titleColumns}>{props.title}</div>
        <div className={`bold text-end ellipsis ` + valueColumns} data-e2e-id={"loanDetail-" + props.title}>{props.value}</div>
      </div>
    );
  };

  return (
    <div>
      <div className="container-fluid auth-display-interior" style={{ fontSize: "12px" }}>
        <h6 className="text-start bold mb-4">Loan Details</h6>
        <DetailsDisplayField title={"Loan Number"} value={loan.LoanNumber} titleColumns={5} />
        <DetailsDisplayField title={"Loan Type"} value={loan.LoanType} titleColumns={5} />
        <Show condition={loan.Collateral || loan.CollateralDetail}>
          <DetailsDisplayField
            title={"Collateral"}
            value={loan.Collateral || loan.CollateralDetail}
            titleColumns={5}
          />
        </Show>
        <div className="my-4 divider" />
        <DetailsDisplayField title={"Current Balance"} value={usd.format(loan.CurrentBalance)} />
        <Show condition={loan.IsOpenEndedLoan}>
          <DetailsDisplayField
            title={"Available Credit"}
            value={usd.format(loan.AvailableCredit)}
          />
          <DetailsDisplayField title={"Credit Limit"} value={usd.format(loan.CreditLimit)} />
        </Show>
        <Show condition={!loan.IsCreditOrExternalAccount}>
          <DetailsDisplayField
            title={"Payoff Amount"}
            value={usd.format(loan.TenDayPayoffAmount)}
          />
        </Show>
        <Show condition={!loan.IsCreditOrExternalAccount}>
           <DetailsDisplayField title={"Interest Rate"} value={`${loan.InterestRate.toFixed(2)}%`} />
        </Show>
        <div className="my-4 divider" />
        <DetailsDisplayField title={"Amount Due"} value={usd.format(loan.AmountDue)} />
        <DetailsDisplayField
          title={"Due Date"}
          value={loan.NextDueDate != null ? moment(loan.NextDueDate).format("MM/DD/YYYY") : "N/A" }
        />
        <button className="w-100 primary" onClick={props.closeModal} data-e2e-id="closeLoanDetailsButton">
          Close
        </button>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/authenticated-payments/modal/loan-details-content.component.js